import { clearMarkFields } from "@cva/shared";
import { toast } from "sonner";
import type { EditorStore } from "./store";

export async function pickScreenColor(): Promise<string | null> {
  if (!("EyeDropper" in window)) {
    toast.info("Die Farbpipette wird von diesem Browser nicht unterstützt.");
    return null;
  }
  try {
    const EyeDropper = (
      window as unknown as {
        EyeDropper: new () => { open(): Promise<{ sRGBHex: string }> };
      }
    ).EyeDropper;
    return (await new EyeDropper().open()).sRGBHex;
  } catch {
    return null;
  }
}

/** Applies a sampled colour to the selection, or the current page background. */
export async function sampleSelectionColor(store: EditorStore) {
  if (store.getState().readOnly) return;
  const { selection, doc, pageIndex } = store.getState();
  const pageId = doc.pages[pageIndex]?.id;
  const color = await pickScreenColor();
  if (!color || store.getState().readOnly) return;
  store.getState().update((draft) => {
    if (selection.length === 0) {
      const page = draft.pages.find((page) => page.id === pageId);
      if (page) {
        page.background = color;
        if (page.brand) delete page.brand.background;
      }
    }
    for (const id of selection) {
      const element = draft.elements[id];
      if (!element || element.locked) continue;
      if (element.type === "text") {
        element.style.color = color;
        clearMarkFields(element, ["color"]);
        if (element.brand) delete element.brand.color;
      } else if (element.type === "shape") {
        if (element.shape === "line") {
          if (element.stroke) element.stroke.color = color;
          if (element.brand) delete element.brand.stroke;
        } else {
          element.fill = color;
          if (element.brand) delete element.brand.fill;
        }
      } else if (
        element.type === "icon" ||
        element.type === "path" ||
        element.type === "chart" ||
        element.type === "qr"
      ) {
        element.color = color;
        if (element.brand) delete element.brand.color;
      }
    }
  });
}
